import PatientStatesContainer from './PatientStatesContainer';

export default PatientStatesContainer;
